<div class="row pt-5" style="text-transform: uppercase;">
    <div class="col-md-6">
        <div class="card p-3 mb-3">
            <h4 class="pb-2 border-bottom skill-heading">
                Technical Skills
            </h4>
            <div *ngFor="let skill of technicalSkills | async">
                <p class="headingtext">
                    {{ skill.name }}
                </p>
                <mat-progress-bar mode="determinate" [value]="skill.value"></mat-progress-bar>
                <br>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card p-3 mb-3">
            <h4 class="pb-2 border-bottom skill-heading">
                Soft Skills
            </h4>
            <div *ngFor="let skill of softSkills | async">
                <p class="headingtext">
                    {{ skill.name }}
                </p>
                <mat-progress-bar mode="determinate" [value]="skill.value"></mat-progress-bar>
                <br>
            </div>
        </div>
    </div>
</div>
